import React, { cloneElement } from 'react';
import { TopToolbar, sanitizeListRestProps, Button } from 'react-admin';

import AddIcon from '@material-ui/icons/Add';
import AssignmentIcon from '@material-ui/icons/Assignment';

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  enabledCreate,
  handleCriar = () => {},
  handleCarregarXml = () => {},
  handleResumoMercadoriasPeriodo = () => {},
  ...rest
}) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <Button onClick={handleCriar} label="Novo">
      <AddIcon />
    </Button>
    <Button
      onClick={handleResumoMercadoriasPeriodo}
      label="Resumo Mercadorias no Período"
    >
      <AssignmentIcon />
    </Button>
    {/*<Button onClick={handleCarregarXml} label="Teste Carregar Nota">
      <PublishIcon />
    </Button>*/}
  </TopToolbar>
);

export default ListActions;
